import { useLiveResource } from "@lib/hooks/useLiveResource";

export function useCampaignListChannel(onUpdate: () => void) {
  useLiveResource({
    channel: "CampaignListChannel",
    onInvalidate: onUpdate,
  });
}
